import script from "./SaveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveButton.vue?vue&type=script&setup=true&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=1c2da5c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2da5c2"]])

export default __exports__